import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { ToastService } from './services/toast.service';
import { WinesService } from './services/wines.service';
import { WineryStoryService } from './services/winery-story.service';
import { AuthService } from './services/auth.service';
import { GooglePlacesService } from './services/google-places.service';
import { TOASTS } from '@shared/partner-ui/services/toast.token';
import { WINES_API } from '@shared/partner-ui/services/wines-api';
import { WINERY_STORY_API } from '@shared/partner-ui/services/winery-story-api';
import { WINERY_ACCOUNT_API } from '@shared/partner-ui/services/winery-account-api';
import { GOOGLE_PLACES_API } from '@shared/partner-ui/services/google-places-api';
import { impersonationErrorInterceptor } from './core/http-interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([impersonationErrorInterceptor])),
    { provide: TOASTS, useExisting: ToastService },
    { provide: WINES_API, useExisting: WinesService },
    { provide: WINERY_STORY_API, useExisting: WineryStoryService },
    { provide: WINERY_ACCOUNT_API, useExisting: AuthService },
    { provide: GOOGLE_PLACES_API, useExisting: GooglePlacesService }
  ]
};
